import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Container,
  Title,
  ContentSection,
  DescriptionParagraph,
  Wrapper,
  Horizontal,
  BackgroundImage,
  Fall,
  SecondaryHorizontal,
  SecondaryTitle,
  LivelySectionHorizontal,
  ScrollIndicatorIcon,
  ScrollIndicatorSection,
  ScrollIndicatorText
} from "./descriptionStyles";
import ReactPlayer from 'react-player'
import playIcon from '../../assets/ademars/1_landing_page/play-icon@2x.png'

import { TweenMax, Power4 } from "gsap";
import { withRouter } from "react-router-dom";
import videoPoster from '../../assets/ademars/2_behind_scenes/video-poset-world@2x.png'
import fallImageOne from '../../assets/ademars/2_behind_scenes/Rocks_carousel.png'
import fallImageTwo from '../../assets/ademars/2_behind_scenes/Stage_Build.png'
import fallImageThree from '../../assets/ademars/2_behind_scenes/Tables.png'
import posterVideoTwo from '../../assets/ademars/2_behind_scenes/poster-3-video-2.png'
import firstBookImage from '../../assets/ademars/3_website_push/Firstbook_White.png'


import ReactGa from "react-ga";
import theme from "../../modules/themes";
import Footer from "../../components/Footer";

function Description({legal,showScrollIndicator}) {

  const [durationPlayed, setDurationPlayed] = useState(0)

  let screen = useRef(null);

  useEffect(() => {
    TweenMax.to(screen, 1, {
      css: {
        opacity: "1",
        pointerEvents: "auto",
        ease: Power4.easeInOut,
      },
    }).delay(1.9);
    return () => {
      TweenMax.to(screen, 1, {
        css: {
          opacity: "0",
          pointerEvents: "none",
        },
      });
    };
  },[]);

  return (
    <Fragment>
      <Wrapper>
        <BackgroundImage>
          <Container
            ref={(ref) => {
              screen = ref;
            }}
          >
            <ContentSection>
              <Title >
                {/* <p className="first">
                  Immersive  
                </p> */}
              </Title>
              <Title >
                {/* <p className="second">
                  Bourbon Tasting
                </p> */}
              </Title>
              <DescriptionParagraph>
              {/* Legent<sup>TM</sup> is excited to present a 
              new masterclass to ignite the senses in virtual world, 
              using sight and sound to amplify moments of tastings as 
              well as tactics to bring the pre and post tasting to life.   */}
              </DescriptionParagraph>
            </ContentSection>
            <ScrollIndicatorSection>
              <ScrollIndicatorText>
                Swipe down to learn more
              </ScrollIndicatorText>
              <ScrollIndicatorIcon size={25}>Icon</ScrollIndicatorIcon>
          </ScrollIndicatorSection>
          </Container>
          <img 
          style={{width:'60%', position:'absolute', top:'50%', left:'50%', transform: 'translate(-50%, -50%)'}}
           src={firstBookImage} />
        </BackgroundImage>
          <Fall>
            <div className="fall-container">
              <SecondaryTitle style={{lineHeight:'0.8'}}>
                The Charity
              </SecondaryTitle>
              <SecondaryTitle style={{fontFamily:'times-now-extra-light'}}>
                First Book
              </SecondaryTitle>
              <p className="para-one">
                First Book believes that education is the best way out of poverty for children in need. First Book aims to remove barriers to quality education for all kids by making everything from new, high-quality books and educational resources to sports equipment, winter coats, snacks, and more – affordable to its member network of more than 500,000 educators who exclusively serve kids in need.
                <br/><br/>
                Since 1992, First Book has distributed more than 185 million books and educational resources to programs and schools serving children from low-income communities in more than 30 countries. First Book currently reaches an average of 5 million children every year and supports more than one in three of the estimated 1.3 million classrooms and programs serving children in need.
                <br/><br/>
                With an additional 1,000 educators joining each week, First Book is the largest and fastest-growing network of educators in the United States exclusively serving kids in need. First Book members work in classrooms, after school and summer or early childhood programs, shelters and health clinics, libraries, community programs, military support programs, and other settings serving a majority of children in need. Learn more in our 2019 Annual Report.
                <br/><br/>
                First Book is rooted in diversity, inclusion, and togetherness and we aim to apply our expertise to join the fight for racial equity. 
                <br/>
              </p>
            </div>
              <a 
                target="_blank"
                href="https://firstbook.org/"
                rel="noopener noreferrer"
                className="book-button">
                  Visit Firstbook.org
              </a>
          </Fall>
          <Footer/>
      </Wrapper>
    </Fragment>
  );
}

export default withRouter(Description);
